import { Puzzle } from "components/icons/generated";
import useContextSearchForNavigation from "shared/Context/useSearchForNavigation";

import CommandPaletteEntitySearch from "./EntitySearch";

const useSearchHook = ({ query }: { query: string }) => {
  return useContextSearchForNavigation({ query });
};

const CommandPaletteSubListViewContextsSearch = () => (
  <CommandPaletteEntitySearch
    useSearchHook={useSearchHook}
    icon={Puzzle}
    pathPrefix="/context/"
    entityName="contexts"
  />
);

export default CommandPaletteSubListViewContextsSearch;
